// extracted by mini-css-extract-plugin
module.exports = {"gridBg":"style_gridBg__TtYjR"};